import classNames from 'classnames'
import {colorCodes, fillColorNone, round} from 'definitions/constant'
import {SvgIcon} from '../SvgIcon'

export const InformationIcon: SvgIcon = ({
  width = 14,
  height = 14,
  strokeColor = 'text-gray-1000',
  strokeWidth,
  fillColor = fillColorNone,
  classes,
  onClick,
}) => (
  <svg
    data-cy="content-information-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 6C6.27614 6 6.5 6.22386 6.5 6.5V7.5C6.5 7.77614 6.27614 8 6 8C5.72386 8 5.5 7.77614 5.5 7.5V6.5C5.5 6.22386 5.72386 6 6 6Z"
      className="fill-current"
    />
    <path
      strokeWidth={strokeWidth}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 4.5C5.5 4.22386 5.72386 4 6 4C6.27614 4 6.5 4.22386 6.5 4.5C6.5 4.77614 6.27614 5 6 5C5.72386 5 5.5 4.77614 5.5 4.5Z"
      className="fill-current"
    />
    <path
      strokeWidth={strokeWidth}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2.75C4.20507 2.75 2.75 4.20507 2.75 6C2.75 7.79493 4.20507 9.25 6 9.25C7.79493 9.25 9.25 7.79493 9.25 6C9.25 4.20507 7.79493 2.75 6 2.75ZM2 6C2 3.79086 3.79086 2 6 2C8.20914 2 10 3.79086 10 6C10 8.20914 8.20914 10 6 10C3.79086 10 2 8.20914 2 6Z"
      className="fill-current"
    />
  </svg>
)

export const TrashIcon: SvgIcon = ({
  width,
  height,
  strokeColor = '#5E6366',
  strokeWidth = 1.2,
  fillColor = fillColorNone,
  classes,
  onClick,
  datacy = 'trash-icon',
  ariaLabel,
}) => (
  <svg
    data-cy={datacy}
    aria-label={ariaLabel}
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    className={classNames('stroke-current', strokeColor, classes)}
  >
    <path
      d="M3.9375 4.52148L4.42817 10.1642C4.4806 10.7671 4.98529 11.2298 5.59045 11.2298H8.40955C9.01471 11.2298 9.5194 10.7671 9.57183 10.1642L10.0625 4.52148"
      stroke={strokeColor}
      strokeLinecap={round}
      strokeLinejoin={round}
    />
    <path
      d="M5.6875 4.37565V3.93815C5.6875 3.29382 6.20983 2.77148 6.85417 2.77148H7.14583C7.79017 2.77148 8.3125 3.29382 8.3125 3.93815V4.37565"
      stroke={strokeColor}
      strokeLinecap={round}
      strokeLinejoin={round}
    />
    <path
      d="M2.9165 4.52148H11.0832"
      stroke={strokeColor}
      strokeLinecap={round}
      strokeLinejoin={round}
      strokeWidth={strokeWidth}
    />
  </svg>
)

export const ResetIcon: SvgIcon = ({
  width = 22,
  height = 20,
  fillColor = colorCodes.purple50,
  classes,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 17"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    data-cy="reset-icon"
    onClick={onClick}
    className={`${classes}`}
  >
    <path d="M12.9125 11.3079C12.7386 11.1298 12.4669 11.1165 12.2784 11.2768C11.6027 11.827 10.7519 12.0802 9.90406 11.9834C9.05622 11.8865 8.27636 11.4469 7.72712 10.7573C7.17785 10.0672 6.90153 9.17944 6.95612 8.27928C7.01071 7.37913 7.39159 6.53627 8.01939 5.92567C8.64762 5.31551 9.47402 4.98467 10.3265 5.00332C11.1794 5.02153 11.9924 5.387 12.5967 6.02382L11.6741 6.99946L15 7.83788L14.2067 4.32071L13.264 5.31767V5.31811C12.488 4.497 11.4415 4.0254 10.3442 4.00096C9.24693 3.97698 8.18286 4.40196 7.37487 5.18794C6.56692 5.97352 6.0773 7.05885 6.00839 8.21741C5.93952 9.37597 6.29647 10.5177 7.00489 11.4046C7.71332 12.2914 8.7186 12.854 9.81008 12.9752C10.9019 13.0969 11.9958 12.7674 12.863 12.056C12.9717 11.9685 13.0397 11.8353 13.049 11.6914C13.0586 11.5471 13.0087 11.4054 12.9125 11.3028L12.9125 11.3079Z" />
  </svg>
)

export const PoliciesTesterIcon: SvgIcon = ({
  width = 12,
  height = 22,
  strokeColor = '',
  strokeWidth = 0.5,
  onClick,
  classes = '',
}) => (
  <svg
    data-cy="policy-tester-icon"
    onClick={onClick}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${strokeColor} ${classes} cursor-pointer`}
  >
    <path
      className="fill-current stroke-current"
      d="M1.57584 13.5961L6.86236 11.9434L6.26549 18.8011L10.4238 8.40539L5.1373 10.058L5.73418 3.20038L1.57584 13.5961ZM1 14.1272L6.26566 0.962891L5.51625 9.58753L11 7.87445L5.73434 21.0388L6.48375 12.4141L1 14.1272Z"
      strokeWidth={strokeWidth}
      strokeLinejoin="round"
    />
  </svg>
)

export const DotIcon: SvgIcon = ({
  width = 6,
  height = 6,
  fillColor = colorCodes.cyanBright,
  datacy = 'dot-icon',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 6 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-cy={datacy}
  >
    <circle cx="3" cy="3" r="3" fill={fillColor} />
  </svg>
)

export const PolicyLockIcon: SvgIcon = ({
  width = 12,
  height = 11,
  datacy = 'lock-icon',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-cy={datacy}
  >
    <path
      d="M2.896 4.89518C2.896 4.66506 3.08254 4.47852 3.31266 4.47852H7.68766C7.91778 4.47852 8.10433 4.66506 8.10433 4.89518V7.18685C8.10433 7.64709 7.73123 8.02018 7.271 8.02018H3.72933C3.26909 8.02018 2.896 7.64709 2.896 7.18685V4.89518Z"
      stroke={colorCodes.cyanBright}
      strokeLinecap={round}
      strokeLinejoin={round}
    />
    <path
      d="M3.72936 4.37435V4.3088C3.72936 3.6583 3.69022 2.9332 4.14455 2.46764C4.40365 2.20214 4.82291 1.97852 5.50019 1.97852C6.17748 1.97852 6.59674 2.20214 6.85584 2.46764C7.31016 2.9332 7.27103 3.6583 7.27103 4.3088V4.37435"
      stroke={colorCodes.cyanBright}
      strokeLinecap={round}
      strokeLinejoin={round}
    />
  </svg>
)

export const UnlockIcon: SvgIcon = ({
  width = 12,
  height = 11,
  datacy = 'unlock-icon',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 11 10"
    fill="none"
    data-cy={datacy}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.896 4.89518C2.896 4.66506 3.08254 4.47852 3.31266 4.47852H7.68766C7.91778 4.47852 8.10433 4.66506 8.10433 4.89518V7.18685C8.10433 7.64709 7.73123 8.02018 7.271 8.02018H3.72933C3.26909 8.02018 2.896 7.64709 2.896 7.18685V4.89518Z"
      stroke={colorCodes.cyanBright}
      strokeLinecap={round}
      strokeLinejoin={round}
    />
    <path
      d="M3.7293 4.37435V4.10078C3.7293 3.5889 3.70885 3.04053 4.0102 2.62676C4.24956 2.2981 4.69047 1.97852 5.50013 1.97852C5.81999 1.97852 6.09382 2.0706 6.30982 2.18407"
      stroke={colorCodes.cyanBright}
      strokeLinecap={round}
      strokeLinejoin={round}
    />
  </svg>
)

export const RBACEyeIcon: SvgIcon = ({width = 24, height = 24}) => (
  <svg
    data-cy="eye-icon"
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.75 12C19.75 13 17.8793 18.25 12 18.25C6.12069 18.25 4.25 13 4.25 12C4.25 11 6.12069 5.75 12 5.75C17.8793 5.75 19.75 11 19.75 12Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SimpleCheckIcon: SvgIcon = ({
  width = 24,
  height = 24,
  classes,
}) => (
  <svg
    data-cy="simple-check-icon"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
  >
    <path
      d="M5 13L9 17L19 7"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SimpleCrossIcon: SvgIcon = ({
  width = 24,
  height = 24,
  classes,
}) => (
  <svg
    data-cy="simple-cross-icon"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
  >
    <path
      d="M6 6L18 18M6 18L18 6"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
